import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {  AllPackingMehodsResponseModel, PackingMethodDto, PackingMethodResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository } from 'typeorm';
// import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { PackingMethodCapacityRequest } from './dto/package-method-capacity.request';
import { PackingMethodRequest } from './dto/packing-mathods.request';
import { PackingMethodAdapter } from './dto/packing-methods.adapter';
import { PackingMethodsDTO } from './dto/packing-methods.dto';
import { UserRequestDto } from './dto/user-logs-dto';
import { PackingMethod } from './packing-methods.entity';

@Injectable()
export class PackingMathodsService {
    constructor(
      private logService:LogsService,

        @InjectRepository(PackingMethod) private packingMethodRepository: Repository<PackingMethod>,
        private packingMethodAdapter: PackingMethodAdapter,
      ) { }
      
      async createPackingMethod(PackingMethodsDto: PackingMethodsDTO, isUpdate: boolean,request:Request): Promise<PackingMethodResponseModel> {
          try {
          let previousValue
          //this section will be executed while creating a new user only
          if (!isUpdate) {
              const packingMethodEntity = await this.getPackMethods(PackingMethodsDto.packingMethodName,PackingMethodsDto.noOfPouches,PackingMethodsDto.pouchesPerRow,PackingMethodsDto.uomId);
            if (packingMethodEntity) {
              throw new PackingMethodResponseModel(false,11104, 'Packing Method already exists');
            }
          }
          else{
            const certificatePrevious = await this.packingMethodRepository.findOne({where:{packingMethodId:PackingMethodsDto.packingMethodId}})
            previousValue = certificatePrevious.packingMethodName+","+certificatePrevious.noOfPouches+','+certificatePrevious.pouchesPerRow+","+certificatePrevious.palletCapacity;
            const packingMethodEntity = await this.getPackMethods(PackingMethodsDto.packingMethodName,PackingMethodsDto.noOfPouches,PackingMethodsDto.pouchesPerRow,PackingMethodsDto.uomId);
            if (packingMethodEntity) {
              if(packingMethodEntity.packingMethodId!=PackingMethodsDto.packingMethodId) {
                throw new PackingMethodResponseModel(false,11104, 'Packing Method already exists');
              }
            }
          }
          const packingMethodEntity: PackingMethod = this.packingMethodAdapter.convertDtoToEntity(PackingMethodsDto,isUpdate);
          const savedpackingMethodsEntity: PackingMethod = await this.packingMethodRepository.save(packingMethodEntity);
          const savedPackMethodDto: PackingMethodsDTO = this.packingMethodAdapter.convertEntityToDto(savedpackingMethodsEntity);
         
           if (savedPackMethodDto) {
            const presentValue = PackingMethodsDto.packingMethodName+","+savedPackMethodDto.noOfPouches+','+PackingMethodsDto.pouchesPerRow+","+PackingMethodsDto.palletCapacity;;
            const response = new PackingMethodResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Packing Method Updated Successfully':'Packing Method Created Successfully',savedPackMethodDto);
            const name=isUpdate?'updated':'created'
            const displayValue = isUpdate? 'Packing Method Updated Successfully': 'Packing Method Created Successfully'
            const userName = isUpdate? savedPackMethodDto.updatedUser :savedPackMethodDto.createdUser;

            const newLogDto = new LogsDto(1,name, 'PackingMethod', savedPackMethodDto.packingMethodId, true, displayValue,userName,previousValue,presentValue)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
          } else {
            throw new PackingMethodResponseModel(false,11106,'Packing Method saved but issue while transforming into DTO');
          }
        }
        catch (error) {
          return error;
        }
      }

         /**
     * gets all  packing methods details  
     * @returns all the packing method details .
     */
  // @LogActions({ isAsync: true })
  async getAllPackingMethods(  req?:UserRequestDto): Promise<AllPackingMehodsResponseModel> {  
    try {
      const packingMethodsDtos: PackingMethodsDTO[] = [];
      // retrieves all plants
      const packMethodEntities: PackingMethod[] = await this.packingMethodRepository.find({relations:['uomInfo'],
        order: { packingMethodName: "ASC" },
      });
      console.log(packMethodEntities);
      if (packMethodEntities.length>0) {
        packMethodEntities.forEach(packMethodEntity => {
          const convertedPackMethodDto: PackingMethodsDTO = this.packingMethodAdapter.convertEntityToDto(packMethodEntity);
          packingMethodsDtos.push(convertedPackMethodDto);
        });
        const response = new AllPackingMehodsResponseModel(true, 11208, "Pack methods retrieved successfully", packingMethodsDtos);
        if (req?.createdUser){
          const newLogDto = new LogsDto(1,'view', 'PackingMethod', 0, true, 'Pack methods retrieved successfully',req.createdUser,'','')
           let res = await this.logService.createLog(newLogDto);
        console.log(res);
        
        }
        
        return response;
      } else {
        //   console.log('yest')
        throw new PackingMethodResponseModel(false,99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }

  async getAllActivePackingMethods(): Promise<AllPackingMehodsResponseModel> {  
    try {
      const packingMethodsDtos: PackingMethodsDTO[] = [];
      // retrieves all plants
      const packMethodEntities: PackingMethod[] = await this.packingMethodRepository.find({relations:['uomInfo'],
        order: { packingMethodName: "ASC" },where:{isActive : true}
      });
      console.log(packMethodEntities);
      if (packMethodEntities.length>0) {
        packMethodEntities.forEach(packMethodEntity => {
          const convertedPackMethodDto: PackingMethodsDTO = this.packingMethodAdapter.convertEntityToDto(packMethodEntity);
          packingMethodsDtos.push(convertedPackMethodDto);
        });
        const response = new AllPackingMehodsResponseModel(true, 11208, "Pack methods retrieved successfully", packingMethodsDtos);
        return response;
      } else {
        //   console.log('yest')
        throw new PackingMethodResponseModel(false,99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }


      

       /**
     * It deactivates Pack method 
     * @param packMethodRequest Pack method  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivatePackingMethod(productReq: PackingMethodRequest): Promise<PackingMethodResponseModel> {
        try {
            const PackMethodExists = await this.getPackMethodById(productReq.packingMethodId);
            if (PackMethodExists) {
                if (productReq.versionFlag !== PackMethodExists.versionFlag) {
                    throw new PackingMethodResponseModel(false,10113, 'Someone updated the current Pack method information.Refresh and try again');
                } else {
                    
                        const packMethodSatatus =  await this.packingMethodRepository.update(
                            { packingMethodId: productReq.packingMethodId },
                            { isActive: productReq.isActive,updatedUser: productReq.updatedUser });
                       
                        if (PackMethodExists.isActive) {
                            if (packMethodSatatus.affected) {
                                const packMethodResponse: PackingMethodResponseModel = new PackingMethodResponseModel(true, 10115, 'Pack Method is de-activated successfully');
                                return packMethodResponse;
                            } else {
                                throw new PackingMethodResponseModel(false,10111, 'Pack Method is already deactivated');
                            }
                        } else {
                            if (packMethodSatatus.affected) {
                                const packMethodResponse: PackingMethodResponseModel = new PackingMethodResponseModel(true, 10114, 'Pack Method is activated successfully');
                                return packMethodResponse;
                            } else {
                                throw new PackingMethodResponseModel(false,10112, 'Pack Method is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new PackingMethodResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
          return err;
        }
    }

    async getPackMethods(packMethodName: string,noOfPouches:number,pouchesPerRow:number,uomId:number): Promise<PackingMethod> {
    //  console.log(employeeId);
        const response = await this.packingMethodRepository.findOne({
        where: {packingMethodName: packMethodName,noOfPouches:noOfPouches,pouchesPerRow:pouchesPerRow,uomId:uomId},
        });
        // console.log(response);
        if (response) {
        return response;
        } else {
        return null;
        }
    }

    async getPackMethodById(packingMethodId: number): Promise<PackingMethod> {
    //  console.log(employeeId);
        const response = await this.packingMethodRepository.findOne({
        where: {packingMethodId: packingMethodId},
        });
        // console.log(response);
        if (response) {
        return response;
        } else {
        return null;
        }
    }
    async getPalletCapacity(packingMethodCapacityRequest:PackingMethodCapacityRequest): Promise<PackingMethodResponseModel> {
      try{

        const packingMethodData = await this.packingMethodRepository.findOne({
          where: {noOfPouches:packingMethodCapacityRequest.noOfPouches,pouchesPerRow:packingMethodCapacityRequest.pouchesPerRow,uomId:packingMethodCapacityRequest.uomId},
          });
          console.log(packingMethodData);
          if (packingMethodData!=undefined) {
            const data = new PackingMethodDto(packingMethodData.packingMethodId,packingMethodData.packingMethodName,packingMethodData.noOfPouches,packingMethodData.pouchesPerRow,packingMethodData.palletCapacity,packingMethodData.uomId,packingMethodData.createdUser,packingMethodData.updatedUser,packingMethodData.isActive);
            const response = new PackingMethodResponseModel(true,1101, "Pallet Capacity retrived Successfully", data);
          return response;
          } else {
            const response = new PackingMethodResponseModel(false,1101, "Packing style not found, please add");
            return response;
          }
        } catch (err) {
          return err;
      }
    }
    async getPalletCapacityById(packingMethodCapacityRequest:PackingMethodCapacityRequest): Promise<PackingMethodResponseModel> {
      try{

        const packingMethodData = await this.packingMethodRepository.findOne({
          where: {packingMethodId:packingMethodCapacityRequest.packingMethodId},
          });
          console.log(packingMethodData);
          if (packingMethodData!=undefined) {
            const data = new PackingMethodDto(packingMethodData.packingMethodId,packingMethodData.packingMethodName,packingMethodData.noOfPouches,packingMethodData.pouchesPerRow,packingMethodData.palletCapacity,packingMethodData.uomId,packingMethodData.createdUser,packingMethodData.updatedUser,packingMethodData.isActive,packingMethodData.maxPalletCapacity);
            const response = new PackingMethodResponseModel(true,1101, "Pallet Capacity retrived Successfully", data);
          return response;
          } else {
            const response = new PackingMethodResponseModel(false,1101, "Packing style not found, please add");
            return response;
          }
        } catch (err) {
          return err;
      }
    }
}
